import React, { FC } from 'react';
import { queryClient } from '~/App';
import { TenantType } from '~/api/utils';
import { tenantQueryKey } from '~/hooks/tenant';
import { TextField } from '~/components';
import { useTranslate } from 'react-admin';
import { Longdash } from '~/utils';
import { Business, Individual } from '~/types';
import { Configuration } from '~/api/solutions';
import { get } from 'lodash';
import { useHandbooksQuery } from '~/hooks/useHandbook';

type BranchFieldProps = {
  record: Business | Individual | Configuration;
  source: string;
};

const label = (key: string): string => `components.ra.fields.BranchField.${key}`;

const BranchField: FC<BranchFieldProps> = ({ source = 'branch', record }) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  const tenant = queryClient.getQueryData<TenantType>(tenantQueryKey);
  const { data: handbook } = useHandbooksQuery(tenant?.id);

  const branches = handbook?.branches ?? [];
  const sourceBranch = get(record, source);
  const branchName =
    branches.find((branch) => branch?.id === sourceBranch)?.name ?? sourceBranch ?? Longdash;

  return (
    <TextField label={t('branch')} allowEmpty>
      {branchName}
    </TextField>
  );
};

export default BranchField;
